'use client';
import PropTypes from 'prop-types';
import React__default, { useRef, useEffect } from 'react';
import { PopoverContentInternal } from '../popover/popover-content-internal.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useSwanPopover } from '../popover/popover.context.js';
import { RenderComp } from '../core/render-comp.component.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const propTypes = {
    /**
   * @internal
   * @ignore
   * internal only -  used to open the popover automatically for visual regression testing
   */ __dangerouslySetOpen: PropTypes.bool
};
const propKeysToRemove = Object.keys(propTypes);
/**
 * @subcomponent Menu
 */ const MenuPopover = renderWithRef('MenuPopover', {}, (props, ref)=>{
    const { children, className, placement = 'bottom start', hideArrow = true } = props;
    const { overlayState } = useSwanPopover();
    const popoverRef = useRef(null);
    const combinedRef = assignRefs(ref, popoverRef);
    const classes = new Set([
        'swan-menu-popover',
        'swan-listbox-popover'
    ]);
    if (className) classes.add(className);
    useEffect(()=>{
        // eslint-disable-next-line no-underscore-dangle
        if (props.__dangerouslySetOpen) {
            setTimeout(()=>overlayState.open(), 100);
        }
    // eslint-disable-next-line no-underscore-dangle
    }, [
        overlayState,
        props.__dangerouslySetOpen
    ]);
    return overlayState.isOpen ? /*#__PURE__*/ React__default.createElement(RenderComp, {
        root: PopoverContentInternal,
        forwardedRef: combinedRef,
        propKeysToRemove: propKeysToRemove,
        classNames: classes,
        props: _object_spread({
            placement,
            hideArrow
        }, props)
    }, children) : /* the list needs to be rendered in the dom for the items to be registered with the parent menu */ /*#__PURE__*/ React__default.createElement("div", {
        "aria-hidden": "true",
        className: "swan-display-none"
    }, children);
});

export { MenuPopover };
